import { mapPublishTerms } from './mapPublishTerms';
import { IAddFormPublishTermsResponse } from '../../../../repositories/billing-tariffs/v2/add-form/publish-terms';
import { ILoadPublishTermsSuccess } from '../../types';

export const mapResponse200 = (response: IAddFormPublishTermsResponse): ILoadPublishTermsSuccess => ({
  success: true,
  payload: mapPublishTerms(response),
});
